<template>
  <vue-content-loading :width="300" :height="200">
    <rect
      :x="$vuetify.breakpoint.xsOnly ? 115 : 0"
      :y="$vuetify.breakpoint.xsOnly ? 30 : 0"
      :height="$vuetify.breakpoint.xsOnly ? 70 : 40"
      :width="$vuetify.breakpoint.xsOnly ? 70 : 40" />

    <rect
      :x="$vuetify.breakpoint.xsOnly ? 75 : 45"
      :y="$vuetify.breakpoint.xsOnly ? 115 : 15"
      :rx="5"
      :ry="5"
      :height="14"
      :width="150" />

    <rect
      :x="0"
      :y="$vuetify.breakpoint.xsOnly ? 150 : 40"
      :height="2"
      :width="300" />

    <rect
      :x="120"
      :y="50"
      :rx="2"
      :ry="2"
      :height="10"
      :width="60" />

    <rect
      :x="100"
      :y="65"
      :rx="2"
      :ry="2"
      :height="5"
      :width="100" />

    <rect
      :x="30"
      :y="90"
      :height="1"
      :width="240" />

    <rect
      :x="36"
      :y="110"
      :height="30"
      :width="30" />

    <rect
      :x="36"
      :y="145"
      :rx="2"
      :ry="2"
      :height="5"
      :width="55" />

    <rect
      :x="36"
      :y="152"
      :rx="2"
      :ry="2"
      :height="5"
      :width="60" />

    <rect
      :x="36"
      :y="160"
      :rx="2"
      :ry="2"
      :height="5"
      :width="40" />

    <rect
      :x="188"
      :y="110"
      :rx="2"
      :ry="2"
      :height="10"
      :width="58" />

    <rect
      :x="188"
      :y="122"
      :rx="2"
      :ry="2"
      :height="5"
      :width="40" />

    <rect
      :x="188"
      :y="130"
      :rx="2"
      :ry="2"
      :height="5"
      :width="50" />

    <rect
      :x="188"
      :y="150"
      :rx="2"
      :ry="2"
      :height="10"
      :width="58" />

    <rect
      :x="188"
      :y="162"
      :rx="2"
      :ry="2"
      :height="5"
      :width="40" />

    <rect
      :x="188"
      :y="170"
      :rx="2"
      :ry="2"
      :height="5"
      :width="50" />

  </vue-content-loading>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  components: {
    VueContentLoading,
  },
};
</script>
